import { focusStory } from "../../../mocks/trendData";

const miniUpdates = [
  "品牌方凌晨发布长声明，承诺公开批次送检报告",
  "主播团队回应：正在核实历史直播语境，保留追责权利",
  "监管口径：已关注反映，将按程序开展抽检复核",
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_15%_10%,oklch(var(--primary-100)/0.6),transparent_42%),radial-gradient(circle_at_90%_85%,oklch(var(--accent-100)/0.55),transparent_40%)]"
        aria-hidden="true"
      ></div>
      <div className="container-x relative py-10 md:py-14">
        <nav className="mb-6 flex items-center gap-2 text-xs font-medium text-foreground-500" aria-label="面包屑">
          <a href="#top" className="transition-colors hover:text-primary-600">首页</a>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-800">今日焦点追踪</span>
        </nav>

        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <span className="section-kicker">
              <span className="relative flex h-1.5 w-1.5">
                <span className="absolute inline-flex h-full w-full animate-pulseDot rounded-full bg-primary-500"></span>
              </span>
              {focusStory.tag}
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug tracking-tight text-foreground-950 md:text-4xl">
              {focusStory.title}
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-700 md:text-base">
              {focusStory.lead}
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-medium text-foreground-600">
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-eye-line text-primary-500" aria-hidden="true"></i>
                {focusStory.views} 阅读
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-chat-3-line text-primary-500" aria-hidden="true"></i>
                {focusStory.comments} 讨论
              </span>
              <span className="inline-flex items-center gap-1.5">
                <i className="ri-time-line text-accent-600" aria-hidden="true"></i>
                {focusStory.statusText}
              </span>
            </div>

            <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a href="#timeline" className="btn-primary">
                查看完整时间线
                <i className="ri-arrow-right-line ml-1" aria-hidden="true"></i>
              </a>
              <a href="#feed" className="btn-ghost">看最新动态</a>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="relative">
                <img
                  src={focusStory.image}
                  alt="成分标注争议事件调查示意图，放大镜与报刊文字"
                  title="成分标注争议 · 沸点追踪"
                  className="h-52 w-full object-cover object-top md:h-64"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/55 via-transparent to-transparent" aria-hidden="true"></div>
                <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-bold text-primary-600 backdrop-blur">
                  <span className="relative flex h-1.5 w-1.5">
                    <span className="absolute inline-flex h-full w-full animate-pulseDot rounded-full bg-primary-500"></span>
                  </span>
                  LIVE · 跟进中
                </span>
              </div>
              <div className="p-4 md:p-5">
                <p className="mb-3 text-xs font-semibold text-foreground-500">{focusStory.updateCount}</p>
                <ul className="space-y-2.5">
                  {miniUpdates.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-sm leading-snug text-foreground-800">
                      <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-500" aria-hidden="true"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}